module.exports = __webpack_public_path__ + "img/img12.b81eb879.svg";